module.exports = __webpack_public_path__ + "static/media/recommendations_2.908cbe17.png";